module.exports = __webpack_public_path__ + "static/media/envelope.baf4bd6a.svg";